import React from 'react';
import ProductItemOnPlp from './productItemOnPlp';

const ProductItemWrapper = ({
  LazyImageComponent,
  isGridView,
  lastProductLoaded,
  onAddToWishlist,
  onSizeDeselected,
  onSizeSelected,
  product,
  referrerProductId,
  cleanReferrerProductId,
  totalFetchedProducts,
  uniqueTemplateKey,
  updateProductDetails,
  addProductsReferences,
  removeProductsReferences,
  openNotificationModal,
  isNotificationModalOpen,
}) => (
  <ProductItemOnPlp
    LazyImageComponent={LazyImageComponent}
    isGridView={isGridView}
    lastProductLoaded={lastProductLoaded}
    onAddToWishlist={onAddToWishlist}
    onSizeDeselected={onSizeDeselected}
    onSizeSelected={onSizeSelected}
    product={product}
    referrerProductId={referrerProductId}
    cleanReferrerProductId={cleanReferrerProductId}
    resultPosition={product.resultPosition}
    totalFetchedProducts={totalFetchedProducts}
    uniqueTemplateKey={uniqueTemplateKey}
    updateProductDetails={updateProductDetails}
    addProductsReferences={addProductsReferences}
    removeProductsReferences={removeProductsReferences}
    openNotificationModal={openNotificationModal}
    isNotificationModalOpen={isNotificationModalOpen}
  />
);

export default ProductItemWrapper;
